import footerController from './footer.controller.js';

function pageFooter() {
  return {
    template: require('./bmo.pageFooter.html'),
    controller: footerController
  };
};
export default pageFooter;


// WEBPACK FOOTER //
// ./src/login/footer/bmo.pageFooter.js